const ROUTES = {
  LOGIN:         "/auth/login",
  PROFILE_SETUP: "/auth/profile-setting",
  HOME:          "/",
} as const;

export default ROUTES;